<template>
  <div class="state_wrap">
    <ol class="state_bar">
      <li :class="classPhase1">
        <em>1</em>
        <p>제품 선택</p>
      </li>
      <li :class="classPhase2">
        <em>2</em>
        <p>용량 구성</p>
      </li>
      <li :class="classPhase3">
        <em>3</em>
        <p>최종 신청</p>
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  name: 'PhaseBar',
  props: {
    phase: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      classPhase1: 'active',
      classPhase2: '',
      classPhase3: '',
    };
  },
  watch: {
    phase() {
      this.setPhase();
    },
  },
  created() {
    this.setPhase();
  },
  methods: {
    setPhase() {
      switch (this.phase) {
        case 1:
          this.classPhase1 = 'active';
          this.classPhase2 = '';
          this.classPhase3 = '';
          break;
        case 2:
          this.classPhase1 = 'complete';
          this.classPhase2 = 'active';
          this.classPhase3 = '';
          break;
        case 3:
          this.classPhase1 = 'complete';
          this.classPhase2 = 'complete';
          this.classPhase3 = 'active';
          break;
        default:
          console.error('Phase prop is not set properly!!!');
      }
    },
  },
};
</script>
